import { render, staticRenderFns } from "./EbFooter.vue?vue&type=template&id=7866fc28&scoped=true&"
import script from "./EbFooter.vue?vue&type=script&lang=js&"
export * from "./EbFooter.vue?vue&type=script&lang=js&"
import style0 from "./EbFooter.vue?vue&type=style&index=0&id=7866fc28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7866fc28",
  null
  
)

export default component.exports